import React from 'react';
// import logoImageReport from '../images/ProstatypeGenomics_logo_report.png';
import logoImageReport from '../images/Prostatype_logotype_CMYK.svg';

import './reportHeader.css';


const ReportHeader = ({ formData }) => {
    return (
        <>
            <div className="header-container">
                <img src={logoImageReport} alt="Logo" className="header-logo" />
                <h1 className="header-report-title">
                    Prostatype Genomic Classifier<sup style={{ fontSize: "0.5em" }}>TM</sup> Report
                </h1>
            </div>

            <div className="header-band">
                <h2 className="header-title">Patient Information</h2>
                <h2 className="header-title">Specimen Information</h2>
                <h2 className="header-title">Provider Information</h2>
            </div>
            <div className="summary-info">
                <div className="info-section">
                    <div className="info-content">
                        <p>Patient Name: <strong>{formData.patientName}</strong></p>
                        <p>Medical Record #: <strong>{formData.medicalRecord}</strong></p>
                        <p>Date of Birth: <strong>{formData.dob}</strong></p>
                        <p>Age at Biopsy: <strong>{formData.ageAtBiopsy}</strong></p>
                        <p>Biopsy Result: <strong>{formData.biopsyResult}</strong></p>
                        <p>Pre-Biopsy PSA: <strong>{formData.preBiopsyPsa}</strong></p>
                        <p>Clinical Stage: <strong>{formData.clinicalStage}</strong></p>
                        

                    </div>
                </div>
                <div className="info-section">
                    <div className="info-content">
                        <p>Pathology Specimen #: <strong>{formData.specimen}</strong></p>
                        <p>Collection Date: <strong>{formData.collectionDate}</strong></p>
                        <p>Date of Diagnosis: <strong>{formData.dateOfDiagnosis}</strong></p>
                        <p>PGi Accession Number: <strong>{formData.accession}</strong></p>
                        <p>Received Date: <strong>{formData.receivedDate}</strong></p>
                        <p>Report Date: <strong>{formData.reportDate}</strong></p>
                    </div>
                </div>
                <div className="info-section">
                    <div className="info-content">
                        <p>Account Name: <strong>{formData.accountName}</strong></p>
                        <p>Account #: <strong>{formData.accountNumber}</strong></p>
                        <p>Address: <strong>{formData.address}</strong></p>
                        <p>City, State, Zip Code: <strong>{formData.city}, {formData.state} {formData.zipCode}</strong></p>
                        <p>&nbsp;</p>
                        <p>Ordering Physician: <strong>{formData.orderingPhysician}</strong></p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReportHeader;
